var map = {
	"./putney-2026-10-anna-160.avif": 38970,
	"./putney-2026-10-anna-160.webp": 54911,
	"./putney-2026-10-anna-240.avif": 27288,
	"./putney-2026-10-anna-240.webp": 89073,
	"./putney-2026-10-anna-320.avif": 51837,
	"./putney-2026-10-anna-320.webp": 37831,
	"./putney-2026-10-anna.jpg": 25109,
	"./putney-2026-10-giorgio-160.avif": 53103,
	"./putney-2026-10-giorgio-160.webp": 48418,
	"./putney-2026-10-giorgio-240.avif": 91641,
	"./putney-2026-10-giorgio-240.webp": 29326,
	"./putney-2026-10-giorgio-320.avif": 41298,
	"./putney-2026-10-giorgio-320.webp": 72184,
	"./putney-2026-10-giorgio.jpg": 52418,
	"./putney-2026-10-matilda-160.avif": 77482,
	"./putney-2026-10-matilda-160.webp": 62247,
	"./putney-2026-10-matilda-240.avif": 51128,
	"./putney-2026-10-matilda-240.webp": 78008,
	"./putney-2026-10-matilda-320.avif": 60491,
	"./putney-2026-10-matilda-320.webp": 77583,
	"./putney-2026-10-matilda.jpg": 45871,
	"./putney-2026-10-rosemary-160.avif": 21129,
	"./putney-2026-10-rosemary-160.webp": 11805,
	"./putney-2026-10-rosemary-240.avif": 19175,
	"./putney-2026-10-rosemary-240.webp": 51700,
	"./putney-2026-10-rosemary-320.avif": 62325,
	"./putney-2026-10-rosemary-320.webp": 22718,
	"./putney-2026-10-rosemary.jpg": 85057,
	"./putney-2026-10-shannon-160.avif": 80680,
	"./putney-2026-10-shannon-160.webp": 8055,
	"./putney-2026-10-shannon-240.avif": 21815,
	"./putney-2026-10-shannon-240.webp": 91726,
	"./putney-2026-10-shannon-320.avif": 72474,
	"./putney-2026-10-shannon-320.webp": 40227,
	"./putney-2026-10-shannon.jpg": 14305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89340;